import SigninForm from '@features/signin/signin-form/signin-form';
export default SigninForm;
